import { registerSync, Sync, Color, ListDef, transformers, Direction } from 'olympe';
import {ChartsData} from './ChartsData';

export class ChartsDataSet extends Sync {
    /**
     * @return {string}
     */
    getType() {
        return this.db.getProperty(this.tag, ChartsDataSet.typeProp);
    }

    /**
     * @return {string}
     */
    getLegend() {
        return this.db.getProperty(this.tag, ChartsDataSet.legendProp);
    }

    /**
     * @return {boolean}
     */
    getFill() {
        return this.db.getProperty(this.tag, ChartsDataSet.fillProp);
    }

    /**
     * @return {number}
     */
    getBorderWidth() {
        return this.db.getProperty(this.tag, ChartsDataSet.borderWidthProp);
    }

    /**
     * @return {number}
     */
    getOrder() {
        return this.db.getProperty(this.tag, ChartsDataSet.orderProp);
    }

    /**
     * @return {Color}
     */
    getBorderColor() {
        return this.db.getProperty(this.tag, ChartsDataSet.borderColorProp);
    }

    /**
     * @return {Color}
     */
    getSecondAxis() {
        return this.db.getProperty(this.tag, ChartsDataSet.secondAxisProp);
    }

    /**
     *
     * @return {ChartsData[]}
     */
    getChartsData() {
        return this.db.getRelated(this.tag, ChartsDataSet.chartsDataRel).map(Sync.getInstance);
    }

    /**
     *
     * @return {ChartsData[]}
     */
    getChartsDataList() {
        return new ListDef(this.tag, new transformers.Related(ChartsDataSet.chartsDataRel, Direction.DESTINATION));
    }



}

ChartsDataSet.entry = registerSync('017ac97ec2ffb17559dd', ChartsDataSet);
ChartsDataSet.legendProp = ChartsDataSet.entry.addProperty('017ac981b730254434a8');
ChartsDataSet.typeProp = ChartsDataSet.entry.addProperty('017acd928508cc45fd12');
ChartsDataSet.fillProp = ChartsDataSet.entry.addProperty('017ac98242513016d6eb');
ChartsDataSet.borderWidthProp = ChartsDataSet.entry.addProperty('017ac9828ce008e2860e');
ChartsDataSet.orderProp = ChartsDataSet.entry.addProperty('017ad2bd528f19d69df7');
ChartsDataSet.borderColorProp = ChartsDataSet.entry.addProperty('017ac982c22ed9f26a2a');
ChartsDataSet.secondAxisProp = ChartsDataSet.entry.addProperty('017b54836e9dee1b5d30');
ChartsDataSet.chartsDataRel = ChartsDataSet.entry.addRelation('017ac97f6746bbe1e8bd');

